module.exports = __webpack_public_path__ + "static/deal-490c23e2808f5babbf3e6a5dbc16056b.svg";